// 防钓鱼操作
(function () {
  if (typeof window !== 'undefined' && typeof Image !== 'undefined') {
    const img = new Image();
    img.src =
      `/gateway-api/v1/public/risk/phishing/website?hostName=${escape(window.location.hostname)}`;
  }
}());
